export default "__VITE_ASSET__BvCcQp5e__"